import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import Select2 from "react-select";

const AddClass = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    roleAr: "",
    roleEn: "",
    nameAr: "",
    nameEn: "",
    descriptionEn: "",
    descriptionAr: "",
    isActive: true,
    // school: "",
  });
  const handleSelectChangeSchool = (newValue) => {
    setItem({ ...item, school: newValue });
  };
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameEnError("");
  };
  const [nameEnError, setNameEnError] = useState("");

  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameArError("");
  };
  const [nameArError, setNameArError] = useState("");

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs and jpegs(Required size: 720x1080 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };
  const [optionsSchools, setOptionsSchools] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseItem = "";
    // let responseSchools = [];

    // try {
    //   responseSchools = await axios.get(`/schools`);
    //   setOptionsSchools(
    //     responseSchools.data.data.data.map((item, index) => {
    //       return {
    //         label: item?.name && getFirstNonNullValue(item.name),
    //         value: String(item.id),
    //       };
    //     })
    //   );
    // } catch (error) {
    //   console.log(error);
    // }
    if (props.type === "edit")
      try {
        responseItem = await axios.get(`/classes/${id}`);
        setItem({
          nameEn:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.en
              ? responseItem.data.data.name.en
              : "",
          nameAr:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.ar
              ? responseItem.data.data.name.ar
              : "",
          // image: responseItem?.data?.data?.image
          //   ? responseItem.data.data.image
          //   : "",
          // school:
          //   responseItem?.data?.data?.school !== null
          //     ? {
          //         label: getFirstNonNullValue(
          //           responseItem?.data?.data?.subject?.school
          //         ),
          //         value: String(responseItem?.data?.data?.subject?.id),
          //       }
          //     : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
        });
      } catch (error) {
        console.log(error);
      }

    setIsSaving(false);
  }

  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/classes/${id}`)
      .then((result) => {
        navigate("/admin/classes");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Class`}
      backAction={{
        onAction: () => navigate(`/admin/classes`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          {/* <Text>School</Text>
          <Select2
            options={optionsSchools}
            onChange={handleSelectChangeSchool}
            value={item.school}
            placeholder="Please select a school"
            styles={{
              // Fixes the overlapping problem of the component
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
          /> */}
          <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Name En"
              requiredIndicator
              error={nameEnError}
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Name Ar"
              align="right"
              requiredIndicator
              error={nameArError}
            />
          </FormLayout.Group>

          {/* <Text>
            Image <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".jpeg,.png,.jpg"
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} /> */}

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />

      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (
      !item.nameEn ||
      !item.nameAr
      // (props?.type === "add" && !files?.length)
    ) {
      !item.nameEn && setNameEnError("This field is required");
      !item.nameAr && setNameArError("This field is required");
      // props?.type === "add" &&
      //   !files?.length &&
      //   setImageError("Please upload an image");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.nameEn && form_data.append("name[en]", item.nameEn);
      item.nameAr && form_data.append("name[ar]", item.nameAr);
      // files?.length && form_data.append("image", files[0]);
      form_data.append("is_active", item.isActive ? 1 : 0);
      // form_data.append("school_id", item.school);
      props?.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/classes`, form_data)
            .then((result) => {
              navigate(`/admin/classes`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/classes/${id}`, form_data)
            .then((result) => {
              navigate(`/admin/classes`);
              // toggleActive();
              // setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddClass;
